import {
    Component,
    Input,
    OnInit,
    Output,
    EventEmitter,
    Inject,
} from '@angular/core';
import {
    IContractSigningResponse,
    IUnsignedPayContract,
} from 'src/app/interfaces/patient.interfaces';
import { IDocuments } from 'src/app/interfaces/document.interfaces';
import { PatientService } from 'src/app/services/patient.service';
import { ConfigService } from 'src/app/services/application/config.service.';
import { AlertService } from 'src/lib/ariadna/alert';
import { lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { DOCUMENT } from '@angular/common';
import { Utils } from 'src/app/services/utils';
import { ContractService } from 'src/app/services/contract.service';
import { CookieConsentService } from 'src/app/services/cookie-consent/cookie-consent-service';
// import { IPatient } from 'src/app/interfaces/patient';
@Component({
    selector: 'app-sms',
    templateUrl: './sms.component.html',
    styleUrls: ['./sms.component.scss'],
    standalone: false,
})
export class SmsComponent implements OnInit {
    @Output() public isSmsSend = new EventEmitter<boolean>(false);
    @Input() public payContracts: IUnsignedPayContract[] = []; //TPayContract[] = [];
    @Input() public mobilePhone: string = '';
    private contractId: number | null = null;
    private messageUuid: string | null = null;
    private code: string = '';
    public countdown: number = 120;
    public timer: ReturnType<typeof setTimeout> | null = null;
    public contractsPayCountRec = 0;
    public pin: string[] = ['', '', '', '', '', ''];
    public signingDoc: boolean = false;
    public loadingDocs = false;
    public docCountRec = 0;
    public documents: IDocuments[] = [];
    public loadingContracts = false;
    public loading = false; // Загрузка
    public sms: string = '';
    public contractName: string | undefined = '';
    public isButtonDisabled: boolean = false;
    public isSubmitBtnDisabled: boolean = false;
    public selectedContract: number | null = null;

    public constructor(
        private alertService: AlertService,
        private contractService: ContractService,
        private cookieService: CookieConsentService,
        private auth: AuthService,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    public ngOnInit(): void {
        this.contractsPayCountRec = 0;

        this.contractName = this.payContracts[0].templateName;
    }

    public get maskedPhone(): string {
        if (!this.mobilePhone) return '';
        const digitsOnly = this.mobilePhone.replace(/\D/g, '');
        return `+7(${digitsOnly.slice(1, 4)})***-**-${digitsOnly.slice(9, 12)}`;
    }
    //TODO: Refactor, localuser is not parent patient cookie for family mode, feat not working.
    public async openNotSignContract(contractId: number) {
        this.selectedContract = contractId;
        try {
            const contract = await lastValueFrom(
                this.contractService.getContractPdf(
                    contractId.toString(),
                    this.cookieService.getParentCookieData(),
                ),
            );
            if (!contract) {
                this.alertService.warn(
                    'Документ поврежден! Обратитесь в медицинскую организацию',
                );
                return;
            }
            const file = new File(
                [new Uint8Array(contract.data)],
                `contract_${contractId}.pdf`,
                {
                    type: 'application/pdf',
                },
            );
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.rel = 'noopener noreferrer';
            link.download = `contract_${contractId}.pdf`;

            document.body.appendChild(link);
            link.click();

            setTimeout(() => {
                document.body.removeChild(link);
                URL.revokeObjectURL(fileURL);
            }, 60_000);
        } catch (err: unknown) {
            const errorMessage = Utils.getErrorMessage(
                err,
                'Неизвестная ошибка при подписании',
            );
            this.alertService.error(errorMessage);
        }
    }

    public async confirmSigningCode(): Promise<void> {
        const pinCode = this.pin.join('');
        if (pinCode.length < 6) return;
        this.isSubmitBtnDisabled = true;
        this.code = pinCode;
        if (!this.messageUuid || !this.contractId) {
            this.alertService.error(
                'Произошла ошибка, обновите страницу и попробуйте ещё раз.',
            );
            this.clearSubmitState();
            return;
        }
        try {
            const response = (await lastValueFrom(
                this.auth.confirmAuthCode(
                    this.code,
                    'SMS',
                    this.messageUuid,
                    this.cookieService.getParentCookieData(),
                ),
            )) as IContractSigningResponse[];
            if (response[0].id) {
                this.alertService.success(
                    `Договор с номером ${this.contractId} подписан`,
                );
                clearInterval(this.timer!);
                this.countdown = 120;
                this.backToList();
                this.isSmsSend.emit(true);
            }
        } catch (err: unknown) {
            const errorMessage = Utils.getErrorMessage(
                err,
                'Неизвестная ошибка при подписании',
            );
            this.alertService.error(errorMessage);
        } finally {
            this.clearSubmitState();
        }
    }

    public sendSigningCode(): void {
        if (!this.contractId) return;
        if (this.timer && this.countdown !== 120) {
            this.alertService.warn(
                'Для повторной отправки сообщения, дождитесь завершения таймера.',
            );
            return;
        }
        this.startTimer();

        if (!this.messageUuid) {
            this.auth
                .sendSignContractCode(
                    'CONTRACT_SIGNING',
                    {
                        platform: 'WEB',
                        otpDomain: this.document.location.hostname,
                    },
                    this.contractId,
                    'Подтверждение договора на оказание платных медицинских услуг. Не сообщайте никому!',
                )
                .subscribe({
                    next: (message) => {
                        this.alertService.success(
                            'Сообщение с кодом отправлено на ваш номер телефона.',
                        );
                        this.messageUuid = message.messageUuid;
                    },
                    error: (err) => {
                        this.alertService.error(Utils.getErrorMessage(err));
                    },
                });
        } else {
            this.auth
                .resendAuthenticationCode(this.messageUuid, 'SMS')
                .subscribe({
                    next: (message) => {
                        this.alertService.success(
                            'Сообщение с кодом отправлено на ваш номер телефона.',
                        );
                        this.messageUuid = message.messageUuid;
                    },
                    error: (err) => {
                        this.alertService.error(Utils.getErrorMessage(err));
                    },
                });
        }
    }

    public disablePay(id: number): boolean {
        return true;
    }

    public signDoc(id: number) {
        this.signingDoc = !this.signingDoc;
        this.contractId = id;
        this.messageUuid = null;
        this.contractName = this.payContracts.find(
            (contract) => contract.templateId === id,
        )?.templateName;
        this.sendSigningCode();
    }
    private startTimer(): void {
        if (this.timer) clearInterval(this.timer);
        this.timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0 && this.timer !== null) {
                clearInterval(this.timer);
                this.countdown = 120;
                this.isButtonDisabled = false;
            }
        }, 1000);
        this.isButtonDisabled = true;
    }
    public clearForm(): void {
        this.pin = ['', '', '', '', '', ''];
        for (let i = 0; i < 5; i++) {
            const input = document.getElementById(
                `pin-input-${i}`,
            ) as HTMLInputElement;
            if (input) {
                input.value = ''; // Очищаем значение каждого поля
            }
        }
    }
    public moveToNext(inputIndex: number, e: Event): void {
        const key = e as KeyboardEvent;

        const input = e.target as HTMLInputElement;
        const regex = /^[0-9]$/;

        if (key.key === 'Backspace') {
            if (inputIndex > 0 && input.value === '') {
                const prevInput = document.getElementById(
                    `pin-input-${inputIndex - 1}`,
                ) as HTMLInputElement;
                if (prevInput) {
                    prevInput.focus();
                }
            }
        } else if (regex.test(input.value)) {
            if (inputIndex < this.pin.length - 1) {
                const nextInput = document.getElementById(
                    `pin-input-${inputIndex + 1}`,
                ) as HTMLInputElement;
                if (nextInput) {
                    nextInput.focus();
                }
            }
        } else {
            input.value = '';
            this.pin[inputIndex] = '';
        }
    }

    public backToList(): void {
        this.signingDoc = false;
        this.messageUuid = null;
        // this.clearSubmitState();
    }
    public clearSubmitState(): void {
        this.isSubmitBtnDisabled = false;
        this.clearForm();
    }
}
